import { render, staticRenderFns } from "./advertencia.vue?vue&type=template&id=0eb66964&scoped=true&"
import script from "./advertencia.vue?vue&type=script&lang=js&"
export * from "./advertencia.vue?vue&type=script&lang=js&"
import style0 from "./advertencia.vue?vue&type=style&index=0&id=0eb66964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb66964",
  null
  
)

export default component.exports